import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { NavHeader } from "@/components/NavHeader";
import { HeroKinetic } from "@/components/HeroKinetic";
import { MarqueeEditorial } from "@/components/MarqueeEditorial";
import { ServicesBento } from "@/components/ServicesBento";
import { Accreditations } from "@/components/Accreditations";
import { OwnersStory } from "@/components/OwnersStory";
import { TeamSection } from "@/components/TeamSection";
import { LocationParallax } from "@/components/LocationParallax";
import { TestimonialCards } from "@/components/TestimonialCards";
import { BusinessToolkit } from "@/components/BusinessToolkit";
import { CtaFooter } from "@/components/CtaFooter";
import { scrollToId, scrollToTopNow } from "@/lib/nav";
import { useSeo } from "@/hooks/useSeo";

export default function HomePage() {
  const { hash } = useLocation();

  useSeo({
    title: "Small Business Accountants in Bristol & Bath | Rosevale Accountants",
    description:
      "Owner-led small business accountants at Bristol & Bath Science Park. Limited company accounts, tax returns, bookkeeping, payroll, Xero & QuickBooks. Fixed fees — book a free discovery call.",
    path: "/",
  });

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash), 350);
      return () => clearTimeout(t);
    }
    scrollToTopNow();
  }, [hash]);

  return (
    <div className="grain">
      <NavHeader />
      <main className="relative">
        <HeroKinetic />
        <MarqueeEditorial />
        <ServicesBento />
        <Accreditations />
        <div id="us">
          <OwnersStory />
          <TeamSection />
        </div>
        <LocationParallax />
        <TestimonialCards />
        <BusinessToolkit />
        <CtaFooter />
      </main>
    </div>
  );
}
